export default "#### We’ll reserve your car\n\nOnce you start checkout, we’ll hold your car for 1 hour.\n";